const resource = {
    resource_identifier_in_use: 'معرف الواجهة البرمجية {{indicator}} قيد الاستخدام بالفعل',
    cannot_delete_management_api: 'لا يمكن حذف واجهة برمجة التطبيقات الإدارية لـ Logto.',
    cannot_modify_management_api: 'لا يمكن تعديل واجهة برمجة التطبيقات الإدارية لـ Logto.',
};
export default Object.freeze(resource);
